export default "__VITE_ASSET__BjGRSdUD__"